import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["prefixCls", "component", "className", "aria-label", "setContentRef", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import classNames from 'classnames';
import { composeRef } from 'rc-util/lib/ref';
import devWarning from '../../_utils/devWarning';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
var Typography = function Typography(_ref, ref) {
  var customizePrefixCls = _ref.prefixCls,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'article' : _ref$component,
    className = _ref.className,
    ariaLabel = _ref['aria-label'],
    setContentRef = _ref.setContentRef,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var mergedRef = ref;
  if (setContentRef) {
    devWarning(false, 'Typography', '`setContentRef` is deprecated. Please use `ref` instead.');
    mergedRef = composeRef(ref, setContentRef);
  }
  var Component = component;
  var prefixCls = usePrefixCls('typography');
  var componentClassName = classNames(prefixCls, className);
  return React.createElement(Component, _objectSpread({
    className: componentClassName,
    "aria-label": ariaLabel,
    ref: mergedRef
  }, restProps), children);
};
var RefTypography = React.forwardRef(Typography);
RefTypography.displayName = 'Typography';
var ExportTypography = RefTypography;
export default ExportTypography;